import { action, makeObservable } from 'mobx';

import MenuServiceBase from '../../../../services/menu-service-base';
import type {
  CacheService,
  I$WWrapper,
  MenuService as IMenuService,
  MenuServiceBase as IMenuServiceBase,
  StateService,
} from '../../../../types';

export class MenuService extends MenuServiceBase implements IMenuService {
  constructor(
    $w: I$WWrapper,
    stateService: StateService,
    cacheService: CacheService,
  ) {
    super($w, stateService, cacheService);
    makeObservable<this, Exclude<keyof IMenuService, keyof IMenuServiceBase>>(
      this,
      {
        initializeMenuItems: action,
      },
    );
  }

  initializeMenuItems() {
    if (this.cacheService.hasLoginMenuItems()) {
      this.menuItems = this.cacheService.getLoginMenuItems();
      this.bindMenuItems();
      return;
    }

    this.filterMenuItemsVisibleForRoles();
    this.setNotificationsCount();
    this.cacheService.setLoginMenuItems(this.menuItems);
    this.bindMenuItems();
  }
}
